document.addEventListener('DOMContentLoaded', function() {
    var hamburgerButton = document.querySelector('.hamburger-button');
    window.domUtils.waitForElement('#mega-nav', function () {
        var closeMainDrawer = document.querySelectorAll('.close-main-drawer');

        // Set background overlay when side nav drawer is open
        if (hamburgerButton) {
            document.querySelector('.hamburger-button').addEventListener('click', function () {
                // Add overlay
                document.querySelector('#full-bg').classList.add('open');
            });
        }

        //Add listener to each close icon
        for (var i = 0; i < closeMainDrawer.length; i++) {
            closeMainDrawer[i].addEventListener('click', function () {
                // Remove overlay
                document.querySelector('#full-bg').classList.remove('open');
            });
        }
    });
});